<template>
  <div>
    <div class="card">
      <div class="card-content">
        <h4 class="card-title">Notificaciones</h4>
      </div>
      <v-card>
          <v-list three-line>
        <template v-for="(item, index) in notificaciones">

          <v-divider
            :key="index"
            inset
          ></v-divider>

          <v-list-item  :key="item.creaed_at">
            <v-list-item-content>
              <v-list-item-title v-html="item.texto"></v-list-item-title>
              <v-list-item-subtitle v-html="item.texto_desc"></v-list-item-subtitle>
            </v-list-item-content>

          <v-list-item-icon
             style="cursor: pointer"
            @click="leida(item.id)">
            <v-icon color="blue darken-3">remove_red_eye</v-icon>
          </v-list-item-icon>

          </v-list-item>
        </template>
      </v-list>
      </v-card>
    </div>

  </div>
</template>
<script>
  import moment from 'moment'
  import Vue from 'vue'
  import {
    Table,
    TableColumn,
    Select,
    Option
  } from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'

  export default {
    components: {
      PPagination,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Select.name]: Select,
      [Option.name]: Option
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data () {
      return {
        items: [
          {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
            title: 'Brunch this weekend?',
            subtitle: "<span class='text--primary'>Ali Connors</span> &mdash; I'll be in your neighborhood doing errands this weekend. Do you want to hang out?"
          },
      { divider: true, inset: true },
          {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
            title: 'Summer BBQ <span class="grey--text text--lighten-1">4</span>',
            subtitle: "<span class='text--primary'>to Alex, Scott, Jennifer</span> &mdash; Wish I could come, but I'm out of town this weekend."
          },
      { divider: true, inset: true },
          {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
            title: 'Oui oui',
            subtitle: "<span class='text--primary'>Sandra Adams</span> &mdash; Do you have Paris recommendations? Have you ever been?"
          },
      { divider: true, inset: true },
          {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/4.jpg',
            title: 'Birthday gift',
            subtitle: "<span class='text--primary'>Trevor Hansen</span> &mdash; Have any ideas about what we should get Heidi for her birthday?"
          },
      { divider: true, inset: true },
          {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/5.jpg',
            title: 'Recipe to try',
            subtitle: "<span class='text--primary'>Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos."
          }
        ],
        notificaciones: []
      }
    },
    watch: {
      '$route': 'checkPermissions'
    },
    methods: {
      checkPermissions () {
        let permiso = [22, 23, 24]
        if ((!this.getKey('permisos').some(r => permiso.includes(r))) && this.getKey('role') != '0') {
          localStorage.clear()
          this.$router.push('/login')
          this.$router.go()
        }
      },
      getNotificaciones () {
        this.$http.get('notificaciones').then(
            response => {
              this.notificaciones = response.data.notificaciones
              console.log(this.notificaciones)
            },
            error => {
              console.log(error)
                // this.StepError(error);
            }
        )
      },
      leida (id) {
        let permiso = [24]// si es de oic, marco el visto
        if (this.getKey('permisos').some(r => permiso.includes(r))) {
          this.$http.get('notificaciones/' + id).then(
            response => {
              this.getNotificaciones()
            },
            error => {
              console.log(error)
                // this.StepError(error);
            }
        )
        } else { // si no, el deleted
          this.$http.delete('notificaciones/' + id).then(
            response => {
              this.getNotificaciones()
            },
            error => {
              this.StepError(error)
            }
        )
        }
      }


    },
    created () {
      this.rol = this.getKey('role')
      this.checkPermissions()
      this.getNotificaciones()
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Notificaciones.vue